import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, InvoiceService, UtilityService } from 'app/core/core.module';
import { ReportService } from 'app/core/data/report.service';
import { Dealer, PackingSlip } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';

@Component({
    selector: 'app-packing-slip-detail',
    templateUrl: './packing-slip-detail.component.html',
    styleUrls: ['./packing-slip-detail.component.scss'],
    standalone: false,
})
export class PackingSlipDetailComponent implements OnInit {
    packingSlipId: any;
    packingSlip: PackingSlip;
    dealer: Dealer;
    orderLineDetails: any[];

    dealers: Dealer[];
    paymentMethods: any;
    deliveryOptions: any;
    deliveryMethods: any;

    @ViewChild('linesGrid') linesGrid: DxDataGridComponent;

    constructor(
        private uow: GenesisUnitOfWork,
        private route: ActivatedRoute,
        private router: Router,
        public auth: AuthService,
        private appInfo: AppInformationService,
        protected location: Location,
        private reportService: ReportService,
    ) {}

    // @HostListener allows us to also guard against browser refresh, close, etc.
    @HostListener('window:beforeunload')
    canDeactivate() {
        return !this.hasChanges();
    }

    async ngOnInit() {
        this.packingSlipId = this.route.snapshot.params.id;

        this.paymentMethods = await this.uow.invoicePaymentMethods.whereActive('displayOrder');
        this.deliveryMethods = this.uow.lookups.deliveryOptions;
        await this.getData();
        this.setTitle();
    }
    hasChanges() {
        return this.uow.hasChanges();
    }

    setTitle() {
        this.appInfo.title = 'Packing Slip Detail';
    }

    async refresh() {
        this.appInfo.pleaseWaitShow();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        this.packingSlip = (await this.uow.packingSlips.byId(this.packingSlipId, 'orderLineDetails.orderLine.order, orderLineDetails.invoice, dealer')) as PackingSlip;
        this.dealer = this.packingSlip.dealer;

        this.orderLineDetails = this.packingSlip.orderLineDetails.filter((line) => !line.deleted);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarText',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async save() {
        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
    }

    cancel() {
        this.uow.rollback();
    }

    close() {
        try {
            this.location.back();
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }

    async print() {
        if (this.packingSlip.reportGuid === null) {
            this.packingSlip.reportGuid = crypto.randomUUID();
            await this.uow.commit([this.packingSlip]);
        }
        this.reportService.openPackingSlip([this.packingSlip.reportGuid]);
    }

    async openInvoice(invoiceNumber: number) {
        const entity = await this.uow.getInvoiceByInvoiceNumber(invoiceNumber);
        if (!entity) return;
        this.router.navigate([`/invoices/${entity.id}`]);
    }
}
